var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { CaseApplyManageService } from '~/services/business-service/case-apply-manage.service';
import ApproveDetails from '~/components/collection-manage/collection-application/approve-details.vue';
import { Emit, Prop } from 'vue-property-decorator';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import DataBox from '~/components/common/data-box.vue';
var TurncasesApproved = /** @class */ (function (_super) {
    __extends(TurncasesApproved, _super);
    function TurncasesApproved() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.publiccaseDataSet = [];
        _this.publiccaseselectionList = [];
        _this.SearchModel = {};
        _this.loading = {
            state: false
        };
        _this.rowData = {};
        _this.dialog = {
            approveDetail: false
        };
        return _this;
    }
    TurncasesApproved.prototype.refreshList = function () { };
    TurncasesApproved.prototype.close = function () { };
    TurncasesApproved.prototype.approveDetail = function (row) {
        this.dialog.approveDetail = true;
        this.rowData = row;
    };
    TurncasesApproved.prototype.refreshData = function () {
        var _this = this;
        this.SearchModel = Object.assign(this.turnCaseModel);
        this.SearchModel.flowType = 'TEL_TO_VISIT';
        this.SearchModel.approvalStatus = 'APPROVED_COMPLETED';
        this.SearchModel.applyDateStart = this.turnCaseModel.applyDate[0];
        this.SearchModel.applyDateEnd = this.turnCaseModel.applyDate[1];
        this.SearchModel.applyDate = '';
        this.caseApplyManageService.getProcessApproveMessage(this.SearchModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.publiccaseDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], TurncasesApproved.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], TurncasesApproved.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], TurncasesApproved.prototype, "caseApplyManageService", void 0);
    __decorate([
        Emit('refreshList')
    ], TurncasesApproved.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], TurncasesApproved.prototype, "close", null);
    __decorate([
        Prop()
    ], TurncasesApproved.prototype, "turnCaseModel", void 0);
    TurncasesApproved = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                ApproveDetails: ApproveDetails
            },
        })
    ], TurncasesApproved);
    return TurncasesApproved;
}(Vue));
export default TurncasesApproved;
